
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-detail",
      function () {
        return require("private-next-pages/order-detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-detail"])
      });
    }
  